import React, {useState, useEffect} from 'react'
import useApp from 'hooks/useApp'
import {Button, Layer} from 'components'
import logo from 'images/tmp_logo2.png'
import styles from './index.module.css'
import {showAppVerLayerState} from 'views/setting/states'
import {useRecoilState, useRecoilValue, useSetRecoilState} from 'recoil'
import Native from 'library/native'
import AppInfoFile from 'app_info.json'
import { checkMyDataLinkState, myDataLinkBottomLayerState } from 'states'
//import Global from 'library/Global'

const AppVer = () => {

    const [showAppVerLayer, setShowAppVerLayer] = useRecoilState(showAppVerLayerState)

    console.log("showAppVerLayer", showAppVerLayer)

    const App = useApp()

    const [newestVersion, setNewestVersion] = useState();
    const [isVersionUpdate, setIsVersionUpdate] = useState(false);
    const [mobileInfo] = useState(getMobileType());

    const checkMyDataLink = useRecoilValue(checkMyDataLinkState) // 마데 연동 중 상태값
    const setMyDataLinkBottomLayer = useSetRecoilState(myDataLinkBottomLayerState) // my data 연동 중 화면 진입, 또는 API 호출을 막았을 때 노출되는 bottom layer state

    function getMobileType() {
        console.log("current device", App.device);

        if (App.device) {
            const version = App.device.appVersion;
            switch (App.device.os.toLowerCase()) {
                case "android":
                    return {os: "android", appVersion: version};
                default:
                    return {os: "ios", appVersion: version};
            }
        } else {
            return {os: "NotMobile", appVersion: "1.0"};
        }
    }

    // 현재 기기의 버전과 최신 버전 세팅
    const initMobileVersion = () => {
        console.log("mobileInfo", mobileInfo);
        console.log("android", AppInfoFile.appInfo.android.currentVer);
        console.log("ios", AppInfoFile.appInfo.ios.currentVer);

        //Global.alert("mobileInfo="+JSON.stringify(mobileInfo));
        //Global.alert("AppInfoFile.appInfo="+JSON.stringify(AppInfoFile.appInfo));

        switch (mobileInfo.os) {
            case "android":
                setNewestVersion(AppInfoFile.appInfo.android.currentVer);
                setIsVersionUpdate(mobileInfo.appVersion !== AppInfoFile.appInfo.android.currentVer);
                break;
            case "ios":
                setNewestVersion(AppInfoFile.appInfo.ios.currentVer);
                setIsVersionUpdate(mobileInfo.appVersion !== AppInfoFile.appInfo.ios.currentVer);
                break;
            default: // NotMobile
                setNewestVersion(AppInfoFile.appInfo.android.currentVer);
                setIsVersionUpdate(true); // test 용도
                break;
        }
    }

    // 업데이트 링크
    const goUpdate = () => {
        // 마데2.0 진입 방지 추가
        if (checkMyDataLink === false) {
            setMyDataLinkBottomLayer(true)
            return
        }
        switch (mobileInfo.os) {
            case "android":
                Native.execute("AppManager", "openScheme", function (result) {
                    console.log(JSON.parse(result).result)
                }, {url: AppInfoFile.appInfo.android.updateUrl})
                break;
            case "ios":
                Native.execute("AppManager", "openScheme", function (result) {
                    console.log(JSON.parse(result).result)
                }, {url: AppInfoFile.appInfo.ios.updateUrl})
                break;
            default:
                console.log("App 업데이트 클릭했음.");
                break;
        }
    }

    const VersionUpdate = () => {
        if (isVersionUpdate) {
            return (
                <>
                    <div className="mt_20" style={{fontSize: "1.6rem", fontWeight: 500}}>
                        현재 버전 {mobileInfo.appVersion}</div>
                    <div className="mt_5 text-blue" style={{fontSize: "1.8rem", fontWeight: 500}}>
                        최신 버전 {newestVersion} </div>
                    <Button className="btn btn--md mt_15" style={{width: "auto"}} onClick={goUpdate}>업데이트</Button>
                </>
            )
        } else {
            return (
                <>
                    <span className="mt_20">최신 버전입니다.</span>
                    <div className="mt_20" style={{fontSize: "1.6rem", fontWeight: 500}}>
                        현재 버전 {mobileInfo.appVersion}</div>
                </>
            )
        }

    }

    useEffect(() => {
        if (showAppVerLayer === true) {
            initMobileVersion()
        }
    }, [showAppVerLayer])

    return (
        <Layer show={showAppVerLayer} closeLayer={() => setShowAppVerLayer(false)} title="앱버전">
            <div className="page padding">
                <div className={styles.title}></div>

                {/*<<<<<<<<<<<< 퍼블리싱 원본 >>>>>>>>>>*/}
                {/* 최신버전 */}
                {/* <div className="center-cont">
				<div className="img-box" style={{ width: "6rem", height: "6rem" }}>
					<img src={logo} alt="" />
				</div>
				<span className="mt_20">최신 버전입니다.</span>
				<div className="mt_5" style={{ fontSize: "1.6rem", fontWeight: 500 }}>현재 버전 1.0</div>
			</div> */}

                {/* 현재버전 */}
                {/* <div className="center-cont">
				<div className="img-box" style={{ width: "6rem", height: "6rem" }}>
					<img src={logo} alt="" />
				</div>
				<div className="mt_20" style={{ fontSize: "1.6rem", fontWeight: 500 }}>현재 버전 1.0</div>
				<div className="mt_5 text-blue" style={{ fontSize: "1.8rem", fontWeight: 500 }}>최신 버전 1.1</div>
				<Button className="btn btn--md mt_15" style={{ width: "auto" }}>업데이트</Button>
			</div> */}
                {/*<<<<<<<<<<<< 퍼블리싱 원본 >>>>>>>>>>*/}

                <div className="center-cont">
                    <div className="img-box" style={{width: "12rem", height: "12rem"}}>
                        <img src={logo} alt=""/>
                    </div>
                    <VersionUpdate/>
                </div>
            </div>
        </Layer>
    )
}

export default AppVer
